import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { inputBorderRadiusMedium } from "src/styles/components/constants";

export const senecInputBaseTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            root: {
                minHeight: "34px",
                backgroundColor: theme.palette.neutralGray000.main,
                borderRadius: inputBorderRadiusMedium,
                fieldSet: {
                    color: theme.palette.neutralGray100.main,
                    top: 0,
                    borderRadius: inputBorderRadiusMedium,
                    borderColor: theme.palette.neutralGray20.main,
                },
                "&.MuiNativeSelect-root": {
                    marginTop: "2rem",
                },
                "&.MuiNativeSelect-select": {
                    marginTop: "2rem",
                },
                "&.Mui-disabled": {
                    // disabled and filled input
                    svg: {
                        color: theme.palette.neutralGray50.main + " !important",
                    },
                    "&:has(input:not([value='']))": {
                        backgroundColor: theme.palette.white.main,
                        input: {
                            webkitTextFillColor: theme.palette.neutralGray50.main + " !important",
                        },
                        label: {
                            color: theme.palette.neutralGray50.main + " !important",
                        },
                    },
                },
                "&:not(.Mui-disabled):hover": {
                    backgroundColor: theme.palette.white.main,
                    "& fieldset.MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.neutralGray40.main,
                    },
                },
                "&.Mui-focused": {
                    "& fieldset.MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.deepBlue.main + " !important",
                        borderWidth: "1px",
                    },
                },
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                    display: "none",
                },
                "& input[type=number]": {
                    mozappearance: "textfield",
                },
            },
        },
    };
};
